<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <!-- <v-flex xs6 v-if="user.roleName != 'ADMIN'">
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Whole Sale
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>-->
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field name="saleNo" label="Sale No" type="text" v-model="queryParams.saleNo"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field name="cardNo" label="Card No" type="text" v-model="queryParams.cardNo"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="salepersonName"
                label="Saleperson Name"
                type="text"
                v-model="queryParams.salepersonName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <!-- <v-flex xs12>
              <v-card>
                <v-card-title class="blue darken-3">
                  <span class="headline white--text">Summary</span>
                </v-card-title>
                <v-card-text class="font-weight-bold">
                  <div>
                    <span>Total Net Amount :</span>
                    <v-chip>
                      <span>{{ totalNetAmount | numFormat}}</span>
                    </v-chip>
                    <v-btn
                      color="primary"
                      :loading="buttonLoading"
                      @click="reprintAllSale('printAllSale')"
                    >PRINT ALL</v-btn>
                    <v-btn
                      :loading="buttonLoading"
                      color="success"
                      @click="exportAllSale()"
                    >EXPORT ALL</v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>-->
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="saleList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :must-sort="true"
                  expand
                >
                  <template slot="items" slot-scope="props">
                    <tr @click="props.expanded = !props.expanded">
                      <td>{{ props.item.createdDateInMilliSeconds | format-ms-date }}</td>
                      <td>{{ props.item.saleNo }}</td>
                      <td>{{ props.item.status }}</td>
                      <td>{{ props.item.salePerson }}</td>
                      <td>{{ props.item.cardNo }}</td>
                      <td>{{ props.item.netAmount }}</td>
                      <td>
                        <v-btn flat icon color="blue lighten-2" @click.stop="onEdit(props.item)">
                          <v-icon>edit</v-icon>
                        </v-btn>
                        <!-- <v-btn flat icon color="blue lighten-2" @click.stop="print(props.item.id)">
                          <v-icon>print</v-icon>
                        </v-btn>-->
                      </td>
                    </tr>
                  </template>
                  <template slot="expand" slot-scope="props">
                    <v-card class="elevation-1">
                      <v-card-text>
                        <v-data-table
                          :headers="subHeaders"
                          :items="props.item.saleItems"
                          item-key="props.item.id"
                          hide-actions
                          class="elevation-10"
                        >
                          <template slot="items" slot-scope="subprops">
                            <td class="text-xs">{{ subprops.item.product.name }}</td>
                            <td class="text-xs">{{ subprops.item.product.color }}</td>
                            <td class="text-xs">
                              <v-icon
                                center
                                color="success"
                                v-if="subprops.item.isFOC == true"
                              >check_circle</v-icon>
                            </td>
                            <!-- <td class="text-xs">
                              <v-icon
                                center
                                color="success"
                                v-if="subprops.item.isReturn == true"
                              >check_circle</v-icon>
                            </td>-->
                            <td
                              class="text-xs"
                            >{{ subprops.item.productUnit.factor+"/"+subprops.item.productUnit.unitName}}</td>
                            <td class="text-xs">{{ subprops.item.unitPrice | numFormat }}</td>
                            <td class="text-xs">{{ subprops.item.qty }}</td>
                            <td
                              class="text-xs"
                            >{{ subprops.item.unitPrice * subprops.item.qty | numFormat }}</td>
                            <!-- <td class="text-xs">{{ subprops.item.returnQty }}</td>
                            <td
                              class="text-xs"
                            >{{ subprops.item.unitPrice * subprops.item.returnQty | numFormat }}</td>-->
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- <summary report> -->
    <!-- <div id="printAllSale" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Sale Summary</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From: [{{queryParams.fromDate}}] To: [{{queryParams.toDate}}]</p>
      </div>
      <div style="text-align:left">
        <p style="font-size:15px;margin:0px">Total Amount: {{totalNetAmount | numFormat}}</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Issue Date</th>
              <th style="text-align:left">Issue No</th>
              <th style="text-align:left">Customer Code</th>
              <th style="text-align:left">Customer Name</th>
              <th style="text-align:left">Shop</th>
              <th style="text-align:left">Status</th>
              <th style="text-align:left">Description</th>
              <th style="text-align:left">Net Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allSaleList" :key="index">
              <td style="text-align:left">{{item.issueDateInMilliSeconds | format-ms-date}}</td>
              <td style="text-align:left">{{item.saleNo}}</td>
              <td style="text-align:left">{{item.customer.code}}</td>
              <td style="text-align:left">{{item.customer.name}}</td>
              <td style="text-align:left">{{item.shopName}}</td>
              <td style="text-align:left">{{item.status}}</td>
              <td style="text-align:left">{{item.description}}</td>
              <td style="text-align:left">{{item.netAmount | numFormat}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>-->
  </v-container>
</template>
<script>
import { saleService } from "../../services/sale-service";
import { commonService } from "../../services/common-service";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "SalePersonSaleList",
  components: { Loading },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Saleperson Sale",
        disabled: true
      }
    ],
    headers: [
      { text: "Sale Date", align: "left", value: "createdDate" },
      { text: "Sale No.", value: "saleNo" },
      { text: "Status", value: "status", sortable: false },
      { text: "Saleperson", value: "user" },
      { text: "Card No", value: "card" },
      { text: "Net Amount", value: "netAmount" },
      { text: "Action", value: "name", sortable: false }
    ],
    subHeaders: [
      { text: "Product Name", sortable: false },
      { text: "Product Color", sortable: false },
      { text: "FOC", sortable: false },
      // { text: "Return", sortable: false },
      { text: "Factor/Unit", sortable: false },
      { text: "Unit Price", sortable: false },
      { text: "Qty", sortable: false },
      { text: "Total Amount", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "createdDate",
      totalItems: 0
    },
    saleList: [],
    allSaleList: [],
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "PENDING", value: "PENDING" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" }
    ],
    clonequeryParams: new Object(),
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      saleNo: "",
      status: "",
      cardNo: "",
      salepersonName: "",
      counterId: ""
    },
    totalNetAmount: 0,
    isLoading: false,
    buttonLoading: false,
    fullPage: true,
    shopList: []
  }),
  watch: {
    pagination: {
      handler() {
        this.getSalePersonSaleList();
      },
      deep: true
    }
  },

  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }

    if (this.$route.query.saleNo) {
      this.queryParams.saleNo = this.$route.query.saleNo;
    }

    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.counterId) {
      this.queryParams.counterId = this.$route.query.counterId;
    }

    if (this.$route.query.cardNo) {
      this.queryParams.cardNo = this.$route.query.cardNo;
    }

    if (this.$route.query.salepersonName) {
      this.queryParams.salepersonName = this.$route.query.salepersonName;
    }

    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role.roleName == "SALE") {
      this.queryParams.counterId = user.counterId;
    }
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "SalePersonSaleList",
        query: this.queryParams
      });
      this.getSalePersonSaleList();
      this.clonequeryParams = Object.assign({}, this.queryParams);
    },
    // exportAllSale() {
    //   this.buttonLoading = true;
    //   saleService
    //     .exportSaleExcel(this.clonequeryParams)
    //     .then(res => {
    //       commonService.downloadE(res);
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     })
    //     .finally(() => {
    //       this.buttonLoading = false;
    //     });
    // },
    // reprintAllSale(divName) {
    //   this.buttonLoading = true;
    //   saleService
    //     .getAllSaleList(this.clonequeryParams)
    //     .then(res => {
    //       if (res.data) {
    //         this.totalNetAmount = 0.0;
    //         this.allSaleList = res.data.saleHeaderList;
    //         for (let temp of this.allSaleList) {
    //           this.totalNetAmount += temp.netAmount;
    //         }
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     })
    //     .finally(() => {
    //       var printContents = document.getElementById(divName).innerHTML;
    //       var reprintWindow = window.open(
    //         "",
    //         "MsgWindow",
    //         "width=500,height=500"
    //       );
    //       reprintWindow.document.write(printContents);
    //       setTimeout(() => {
    //         reprintWindow.print();
    //         reprintWindow.close();
    //       }, 600);
    //       this.buttonLoading = false;
    //     });
    // },

    // getAllShop() {
    //   shopService
    //     .getAllShop()
    //     .then(res => {
    //       this.shopList = res.data;
    //       let findAll = {
    //         id: "",
    //         name: "----All----"
    //       };
    //       this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       if (err.response.data) {
    //         this.responseError = err.response.data.message;
    //       }
    //     });
    // },

    getSalePersonSaleList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      saleService
        .getSalePersonSaleList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            //this.totalNetAmount = 0.0;
            this.saleList = res.data.saleList;
            this.totalRows = res.data.totalElements;
            // for (let temp of this.saleList) {
            //   this.totalNetAmount += temp.netAmount;
            // }
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    // onRegister() {
    //   this.$router.push("/whole-sale/new");
    // },

    onEdit(sale) {
      // go to details page
      this.$router.push("/sales/" + sale.id);
    }

    // print(id) {
    //   this.isLoading = true;
    //   saleService
    //     .printInvoiceById(id)
    //     .then(res => {
    //       var blob = res;
    //       saleService.showWindowDialog(blob, "SaleInvoice-" + id);
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     })
    //     .finally(() => {
    //       this.isLoading = false;
    //     });
    // }
  }
};
</script>

